import React from 'react'
import Wallets from '../components/InvestComps/Wallets'
import ImarikaChama from '../components/InvestComps/ImarikaChama'
import ImarikaInvPlan from '../components/InvestComps/ImarikaInvPlan'
import BalancedBondFund from '../components/InvestComps/BalancedBondFund'
import EquityFund from '../components/InvestComps/EquityFund'
import MoneyMarketFund from '../components/InvestComps/MoneyMarketFund'


function Invest() {
  return (
    <div>

      <BalancedBondFund/>
      <EquityFund/>
      <MoneyMarketFund/>
      <ImarikaInvPlan/>
      <ImarikaChama/>
      
      <Wallets/>



    </div>
  )
}

export default Invest